import _ from "lodash"
import colors from "./styleColors"

export default function tooltipPlugin(chartOpts) {
  _.set(chartOpts, "tooltip.backgroundColor", colors.tooltipBackground)
  _.set(chartOpts, "tooltip.borderColor", colors.tooltipBackground)
  _.set(chartOpts, "tooltip.borderWidth", 1)
  _.set(chartOpts, "tooltip.style", { color: colors.contrastTextColor })
  _.set(chartOpts, "tooltip.shadow", false)
  return chartOpts
}
